import React from 'react';
import { Breadcrumbs, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Link, useLocation } from 'react-router-dom';
import KenColors from '../../Helpers/Themes/kenColors';
import { useEventContext } from '../../Helpers/Contexts/eventContext';

const useStyles = makeStyles((theme) => ({
  mainText: {
    fontWeight: '600 !important',
    textDecoration: 'none',
    textTransform: 'capitalize',
    margin: '0px !important',
    padding: '0px !important',
    background: '#f5f8fb',
  },
  listText: {
    textDecoration: 'none',
    textTransform: 'capitalize',
    margin: '0px !important',
    padding: '0px !important',
    background: '#f5f8fb',
  },
}));

const AppBreadCrumbs: React.FunctionComponent = () => {
  const { pathname, state } = useLocation<{ 
    breadCrumbs?: string;
    startupHeader?: {
      Name_of_Product_or_Startup_Venture__c?: string;
    };
  }>();
  const { state: eventState } = useEventContext();
  const classes = useStyles();

  console.log(state?.breadCrumbs, 'state');
  console.log(eventState.currentEventTitle, 'eventContext');

  // Split the current route into parts
  const navigateHistory: Array<string> = pathname.split('/').filter((item) => item && item !== '');
  console.log(navigateHistory,state, 'navigateHistory');
  
  // Determine the title: Prefer state.breadCrumbs, then eventContext, then dynamic title
  let title = state?.breadCrumbs || eventState.currentEventTitle;
  
  if (!title) {
    if (navigateHistory.length > 0) {
      const lastSegment = navigateHistory[navigateHistory.length - 1];
      
      // If this is a startup profile page (contains startup ID pattern), use startup name from state
      if (navigateHistory.includes('startup-profile') && lastSegment.length > 10 && /^[a-zA-Z0-9]{15,18}$/.test(lastSegment)) {
        title = state?.startupHeader?.Name_of_Product_or_Startup_Venture__c || 'Startup Profile';
      }
      // If this is an event detail page (contains event ID pattern), show a better title
      else if (navigateHistory.includes('events') && lastSegment.length > 10 && /^[a-zA-Z0-9]{15,18}$/.test(lastSegment)) {
        title = 'Event Details';
      } else {
        title = lastSegment.replace(/-/g, ' ');
      }
    } else {
      title = 'Home';
    }
  }

  return (
    <>
      {/* Render the title */}
      <Typography 
        className={classes.mainText} 
        color={KenColors.ClientBlack2} 
        fontSize={{ xs: '13px', md: '15px', ultraHD: '20px' }}
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: { xs: '200px', sm: '300px', md: 'none' }
        }}
      >
        {title}
      </Typography>

      {/* Render breadcrumbs without the last segment */}
      {navigateHistory.length > 1 && (
        <Breadcrumbs separator={<Typography sx={{ fontSize: { xs: '10px', md: '12px', lg: '14px' }, fontWeight: '600' }}>&gt;</Typography>} style={{ color: KenColors.ClientBlack2 }}>
          {/* Add Home as the first breadcrumb */}
          {!navigateHistory.includes('home') && (
            <Link to="/home" className={classes.listText}>
              <Typography
                sx={{
                  color: KenColors.ClientBlack1,
                  fontWeight: '500',
                  fontSize: { xs: '10px', md: '12px', ultraHD: '14px' },
                }}
              >
                Home
              </Typography>
            </Link>
          )}

          {/* Dynamically generate breadcrumbs, excluding the last segment */}
          {navigateHistory.slice(0, -1).map((item, index) => {
            const path = `/${navigateHistory.slice(0, index + 1).join('/')}`;
            
            // Handle special cases for breadcrumb display
            let displayText = item.replace(/-/g, ' ');
            if (item === 'startup-profile') {
              displayText = 'Startup Profile';
            }
            
            return (
              <Link key={index} className={classes.listText} to={path}>
                <Typography
                  sx={{
                    color: KenColors.ClientBlack1,
                    fontWeight: '500',
                    fontSize: { xs: '10px', md: '12px', ultraHD: '14px' },
                  }}
                >
                  {displayText}
                </Typography>
              </Link>
            );
          })}
        </Breadcrumbs>
      )}
    </>
  );
};

export default AppBreadCrumbs;
